import { create } from 'zustand'

interface Collection<T> {
  data: T[]
  hydrateWithFreshData: (data: T[]) => void
}

type CollectionStore<T> = ReturnType<typeof createCollection<T>>

const collections: Record<string, CollectionStore<any>> = {}

function createCollection<T>() {
  return create<Collection<T>>((set) => ({
    data: [],
    hydrateWithFreshData: (data) => set({ data }),
  }))
}

// Create or get the store instance
function getOrCreateStore<T>(name: string): CollectionStore<T> {
  if (!collections[name]) {
    collections[name] = createCollection<T>()
  }
  return collections[name]
}

// Hook to use within React components
export function useCollection<T>(name: string): Collection<T> {
  return getOrCreateStore<T>(name)()
}

// Non-hook method to get store instance (for non-React contexts)
export function getCollectionStore<T>(name: string): CollectionStore<T> {
  return getOrCreateStore<T>(name)
}
